import {Pipe, PipeTransform} from '@angular/core';
import {Race} from "@model";

@Pipe({
    name: 'raceCompetitorCountFormat',
    standalone: false
})
export class RaceCompetitorCountFormatPipe implements PipeTransform {

  transform(race: Race | undefined): string | undefined {
    return race
      ? (race?.competitorCount?.total ?? 0) + (race?.maxParticipants ? " / " + race?.maxParticipants :
      "")
      : '-';
  }
}
